import { useState, useEffect } from "react";

const GOOGLE_REVIEW_URL = "https://share.google/iWuTkQgIZBiA1uTEv";
const GLOVO_URL = "https://glovo.go.link/open?link_type=store&store_id=546394&adjust_t=s321jkn";
const MAPS_URL = "https://maps.app.goo.gl/wGtK63wDbPmbbZVj8";

const Tooltip = ({ text }) => (
  <span className="absolute right-[56px] top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#181411] text-white text-xs font-medium px-2.5 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none shadow-lg">
    {text}
    {/* Arrow pointing right */}
    <span className="absolute right-[-4px] top-1/2 -translate-y-1/2 w-2 h-2 bg-[#181411] rotate-45" />
  </span>
);

const FloatingActions = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed right-4 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8 pointer-events-none"
      }`}
    >
      {/* Google Review */}
      <div className="group relative flex items-center">
        <Tooltip text="Rate us on Google" />
        <a
          href={GOOGLE_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Leave a Google review"
          className="relative flex items-center justify-center w-12 h-12 bg-white rounded-2xl shadow-lg border border-gray-100 hover:scale-110 hover:shadow-xl transition-all duration-200"
        >
          <svg viewBox="0 0 24 24" width="22" height="22">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          {/* Star badge */}
          <span className="absolute -top-1 -right-1 bg-yellow-400 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center leading-none">
            ★
          </span>
        </a>
      </div>

      {/* Divider */}
      <div className="w-6 h-px bg-gray-200 mx-auto" />

      {/* Google Maps location */}
      <div className="group relative flex items-center">
        <Tooltip text="Find us on Maps" />
        <a
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Find us on Google Maps"
          className="relative flex items-center justify-center w-12 h-12 bg-white rounded-2xl shadow-lg border border-gray-100 hover:scale-110 hover:shadow-xl transition-all duration-200"
        >
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#EA4335"/>
            <circle cx="12" cy="9" r="2.5" fill="white"/>
          </svg>
        </a>
      </div>

      {/* Divider */}
      <div className="w-6 h-px bg-gray-200 mx-auto" />

      {/* Glovo */}
      <div className="group relative flex items-center">
        <Tooltip text="Order on Glovo" />
        <a
          href={GLOVO_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Order on Glovo"
          className="flex items-center justify-center w-12 h-12 rounded-2xl shadow-lg hover:scale-110 hover:shadow-xl transition-all duration-200 bg-[#FFC244]"
        >
          <svg viewBox="0 0 40 40" width="28" height="28" fill="none">
            <path
              d="M20 8C14.477 8 10 12.477 10 18c0 3.6 1.89 6.76 4.75 8.6L13 32h14l-1.75-5.4A9.96 9.96 0 0 0 30 18c0-5.523-4.477-10-10-10zm0 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"
              fill="#181411"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default FloatingActions;
